export class RecorrenteLink {
  id: string;
  empresaId: string;
  licencaId: string;
  descricao: string;
  valorUnitario: number;
  valorAdesao: number;
  periodicidade: string;
  diasVenctoBoleto: number;
  qtdMin: number;
  qtdMax: number;

  ativarQtd: boolean;
  ativarBoleto: boolean;
  ativarCartao: boolean;
  ativo: boolean;

  link: string;
  linkReduzido: string;

  tpMulta: string;
  vlrMulta: number;
  tpJuros: string;
  vlrJuros: number;

  constructor(empresaId: string) {
      this.empresaId = empresaId;
      this.valorUnitario = 0.00;
      this.valorAdesao = 0.00;
      this.periodicidade = 'MENSAL';
      this.diasVenctoBoleto = 1;
      this.descricao = "";
      this.qtdMin = 1;
      this.qtdMax = 1;
      this.ativarQtd = false;
      this.ativarBoleto = true;
      this.ativarCartao = true;
      this.ativo = true;
      this.tpMulta = 'ISENTO';
      this.vlrMulta = 0.00;
      this.tpJuros = 'ISENTO';
      this.vlrJuros = 0.00;
  }
}
